<template>
	<div>		<el-card class="box-card">
			<!-- 搜索区域 -->
			<el-form :inline="true" :model="queryParams" class="demo-form-inline">
				<el-form-item label="手机号:">
					<el-input v-model="queryParams.memberMobile" placeholder="请输入手机号" clearable style="width: 150px;"></el-input>
				</el-form-item>
				<el-form-item label="运营商:">
					<el-select v-model="queryParams.distributorId" placeholder="请选择运营商" clearable filterable style="width: 180px;">
						<el-option v-for="item in distributorList" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="交易编号:">
					<el-input v-model="queryParams.tradeNo" placeholder="请输入交易编号" clearable style="width: 180px;"></el-input>
				</el-form-item>
				<el-form-item label="车辆编号:">
					<el-input v-model="queryParams.bicycleNumber" placeholder="请输入车辆编号" clearable style="width: 150px;"></el-input>
				</el-form-item>
				<el-form-item label="支付状态:">
					<el-select v-model="queryParams.hasPaid" placeholder="请选择支付状态" clearable style="width: 120px;">
						<el-option label="待支付" :value="0"></el-option>
						<el-option label="已支付" :value="1"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="创建时间:">
					<el-date-picker v-model="dateRange" type="daterange" range-separator="-"
						start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"
						value-format="yyyy-MM-dd" @change="handleDateChange">
					</el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="handleSearch" style="background-color: #3CA757; border-color: #3CA757;">查询</el-button>
					<el-button @click="resetQuery">重置</el-button>
				</el-form-item>
			</el-form>

			<!-- 表格区域 -->
			<el-table :data="orderList" border stripe :header-cell-style="{ textAlign: 'center' }"
				:cell-style="{ textAlign: 'center' }" v-loading="loading">
				<el-table-column type="index" width="60"></el-table-column>
				<el-table-column prop="mobile" label="手机号" width="120"></el-table-column>
				<el-table-column prop="bicycleNumber" label="车辆编号" width="120"></el-table-column>
				<el-table-column prop="startTime" label="开始时间" width="160">
					<template slot-scope="scope">
						<span>{{ formatTime(scope.row.startTime) }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="endTime" label="结束时间" width="160">
					<template slot-scope="scope">
						<span>{{ formatTime(scope.row.endTime) }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="tripTimespan" label="骑行时长(分钟)" width="120"></el-table-column>
				<el-table-column prop="originalFee" label="原价金额" width="100">
					<template slot-scope="scope">
						<span v-if="scope.row.originalFee">{{ scope.row.originalFee }}元</span>
						<span v-else>-</span>
					</template>
				</el-table-column>
				<el-table-column prop="cashAmount" label="应付金额" width="100">
					<template slot-scope="scope">
						<span v-if="scope.row.cashAmount" style="color: #F56C6C; font-weight: bold;">{{ scope.row.cashAmount }}元</span>
						<span v-else>-</span>
					</template>
				</el-table-column>
				<el-table-column prop="premoney" label="押金" width="100">
					<template slot-scope="scope">
						<span v-if="scope.row.premoney">{{ scope.row.premoney }}元</span>
						<span v-else>-</span>
					</template>
				</el-table-column>
				<el-table-column prop="hasPaid" label="支付状态" width="100">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.hasPaid === 0" type="danger" size="small">待支付</el-tag>
						<el-tag v-else-if="scope.row.hasPaid === 1" type="success" size="small">已支付</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="distributor" label="运营商"></el-table-column>
				<el-table-column prop="remark1" label="备注">
					<template slot-scope="scope">
						<span>{{ scope.row.remark1 || '-' }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="insertTime" label="创建时间" width="160">
					<template slot-scope="scope">
						<span>{{ formatTime(scope.row.insertTime) }}</span>
					</template>
				</el-table-column>
				<el-table-column fixed="right" header-align="center" align="center" width="180" label="操作">
					<template slot-scope="scope">
						<el-button size="mini" type="primary" icon="el-icon-view"
							@click="handleView(scope.row)">详情</el-button>
						<el-button size="mini" type="warning" icon="el-icon-edit"
							@click="handleEdit(scope.row)" v-if="scope.row.hasPaid === 0">修改</el-button>
					</template>
				</el-table-column>
			</el-table>

			<!-- 分页区域 -->
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="queryParams.page" :page-sizes="[10, 20, 50, 100]"
				:page-size="queryParams.limit" layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
		</el-card>

		<!-- 详情弹窗 -->
		<el-dialog title="订单详情" :visible.sync="detailDialogVisible" width="600px">
			<el-descriptions :column="2" border>
				<el-descriptions-item label="交易编号">{{ currentOrder.tradeNo }}</el-descriptions-item>
				<el-descriptions-item label="用户名称">{{ currentOrder.memberName }}</el-descriptions-item>
				<el-descriptions-item label="手机号">{{ currentOrder.mobile }}</el-descriptions-item>
				<el-descriptions-item label="车辆编号">{{ currentOrder.bicycleNumber }}</el-descriptions-item>
				<el-descriptions-item label="车辆类型">
					<el-tag v-if="currentOrder.bicycleType === 1" type="success" size="small">自行车</el-tag>
					<el-tag v-else-if="currentOrder.bicycleType === 2" type="primary" size="small">电动车</el-tag>
					<el-tag v-else-if="currentOrder.bicycleType === 3" type="warning" size="small">涨闸锁</el-tag>
				</el-descriptions-item>
				<el-descriptions-item label="骑行时长">{{ currentOrder.tripTimespan }}分钟</el-descriptions-item>
				<el-descriptions-item label="开始时间">{{ formatTime(currentOrder.startTime) }}</el-descriptions-item>
				<el-descriptions-item label="结束时间">{{ formatTime(currentOrder.endTime) }}</el-descriptions-item>
				<el-descriptions-item label="原价金额">{{ currentOrder.originalFee }}元</el-descriptions-item>
				<el-descriptions-item label="应付金额">{{ currentOrder.cashAmount }}元</el-descriptions-item>
				<el-descriptions-item label="押金">{{ currentOrder.premoney }}元</el-descriptions-item>
				<el-descriptions-item label="支付状态">
					<el-tag v-if="currentOrder.hasPaid === 0" type="danger" size="small">待支付</el-tag>
					<el-tag v-else-if="currentOrder.hasPaid === 1" type="success" size="small">已支付</el-tag>
				</el-descriptions-item>
				<el-descriptions-item label="运营商">{{ currentOrder.distributor }}</el-descriptions-item>
				<el-descriptions-item label="创建时间">{{ formatTime(currentOrder.insertTime) }}</el-descriptions-item>
				<el-descriptions-item label="备注" :span="2">{{ currentOrder.remark1 || '-' }}</el-descriptions-item>
			</el-descriptions>
			<span slot="footer" class="dialog-footer">
				<el-button @click="detailDialogVisible = false">关 闭</el-button>
			</span>
		</el-dialog>

		<!-- 修改订单弹窗 -->
		<el-dialog title="修改订单" :visible.sync="editDialogVisible" width="500px" @close="resetEditForm">
			<el-form :model="editForm" :rules="editRules" ref="editFormRef" label-width="100px">
				<el-form-item label="交易编号">
					<span>{{ editForm.tradeNo }}</span>
				</el-form-item>
				<el-form-item label="手机号">
					<span>{{ editForm.mobile }}</span>
				</el-form-item>
				<el-form-item label="车辆编号">
					<span>{{ editForm.bicycleNumber }}</span>
				</el-form-item>
				<el-form-item label="原应付金额">
					<span style="color: #F56C6C; font-weight: bold;">{{ editForm.originalCashAmount }}元</span>
				</el-form-item>
				<el-form-item label="修改后金额" prop="cashAmount">
					<el-input-number v-model="editForm.cashAmount" :min="0" :precision="2" :step="0.5"
						style="width: 200px;"></el-input-number>
					<span style="margin-left: 10px; color: #909399;">元</span>
				</el-form-item>
				<el-form-item label="备注" prop="remark1">
					<el-input v-model="editForm.remark1" type="textarea" :rows="3" placeholder="请输入备注信息"
						maxlength="200" show-word-limit></el-input>
				</el-form-item>
				<el-alert v-if="editForm.cashAmount === 0" title="金额修改为0后，订单将自动标记为已支付" type="warning"
					:closable="false" show-icon style="margin-bottom: 15px;"></el-alert>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="editDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitEdit" :loading="editLoading">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { getCurrentDistributorId } from '@/utils/distributor.js'

export default {
	data() {
		return {
			queryParams: {
				page: 1,
				limit: 10,
				memberMobile: '',
				distributorId: '',
				tradeNo: '',
				bicycleNumber: '',
				hasPaid: 0,
				startDate: '',
				endDate: '',
				queryDistributorId: ''
			},
			dateRange: [],
			orderList: [],
			total: 0,
			loading: false,
			distributorList: [],
			detailDialogVisible: false,
			currentOrder: {},
			editDialogVisible: false,
			editLoading: false,
			editForm: {
				id: '',
				tradeNo: '',
				mobile: '',
				bicycleNumber: '',
				originalCashAmount: 0,
				cashAmount: 0,
				remark1: ''
			},
			editRules: {
				cashAmount: [
					{ required: true, message: '请输入金额', trigger: 'blur' }
				]
			}
		}
	},
	created() {
		this.getDistributorList();
		this.queryParams.queryDistributorId = getCurrentDistributorId()
		this.getOrderList();
		// 监听运营商切换事件
		this.$root.$on('distributorChanged', this.handleDistributorChange)
	},
	beforeDestroy() {
		// 移除事件监听
		this.$root.$off('distributorChanged', this.handleDistributorChange)
	},
	methods: {
		handleDistributorChange(distributorId) {
			this.queryParams.queryDistributorId = distributorId || ''
			this.queryParams.page = 1
			this.getOrderList()
		},
		getDistributorList() {
			this.$http.post('/distributor/manager/list', { page: 1, limit: 1000 }).then(res => {
				if (res.data.code === 200) {
					this.distributorList = res.data.data.list || [];
				}
			});
		},
		getOrderList() {
			this.loading = true;
			this.$http.post('/member/ridingOrder/unpaid/page', this.queryParams).then(res => {
				if (res.data.code === 200) {
					this.orderList = res.data.data.list;
					this.total = res.data.data.total;
				} else {
					this.$message.error(res.data.msg || '获取数据失败');
				}
				this.loading = false;
			}).catch(() => {
				this.loading = false;
			});
		},
		handleSearch() {
			this.queryParams.page = 1;
			this.getOrderList();
		},
		resetQuery() {
			this.queryParams = {
				page: 1,
				limit: 10,
				memberMobile: '',
				distributorId: '',
				tradeNo: '',
				bicycleNumber: '',
				hasPaid: 0,
				startDate: '',
				endDate: '',
				queryDistributorId: getCurrentDistributorId()
			};
			this.dateRange = [];
			this.getOrderList();
		},
		handleDateChange(val) {
			if (val && val.length === 2) {
				this.queryParams.startDate = val[0];
				this.queryParams.endDate = val[1];
			} else {
				this.queryParams.startDate = '';
				this.queryParams.endDate = '';
			}
		},
		handleSizeChange(val) {
			this.queryParams.limit = val;
			this.getOrderList();
		},
		handleCurrentChange(val) {
			this.queryParams.page = val;
			this.getOrderList();
		},
		handleView(row) {
			this.currentOrder = row;
			this.detailDialogVisible = true;
		},
		handleEdit(row) {
			this.editForm = {
				id: row.id,
				tradeNo: row.tradeNo,
				mobile: row.mobile,
				bicycleNumber: row.bicycleNumber,
				originalCashAmount: row.cashAmount,
				cashAmount: row.cashAmount,
				remark1: row.remark1 || ''
			};
			this.editDialogVisible = true;
		},
		resetEditForm() {
			this.editForm = {
				id: '',
				tradeNo: '',
				mobile: '',
				bicycleNumber: '',
				originalCashAmount: 0,
				cashAmount: 0,
				remark1: ''
			};
			if (this.$refs.editFormRef) {
				this.$refs.editFormRef.resetFields();
			}
		},
		submitEdit() {
			this.$refs.editFormRef.validate(valid => {
				if (valid) {
					this.editLoading = true;
					this.$http.post('/member/ridingOrder/update', this.editForm).then(res => {
						if (res.data.code === 200) {
							this.$message.success('修改成功');
							this.editDialogVisible = false;
							this.getOrderList();
						} else {
							this.$message.error(res.data.msg || '修改失败');
						}
						this.editLoading = false;
					}).catch(() => {
						this.$message.error('请求失败');
						this.editLoading = false;
					});
				}
			});
		},
		formatTime(time) {
			if (!time) return '-';
			const date = new Date(time);
			const year = date.getFullYear();
			const month = String(date.getMonth() + 1).padStart(2, '0');
			const day = String(date.getDate()).padStart(2, '0');
			const hours = String(date.getHours()).padStart(2, '0');
			const minutes = String(date.getMinutes()).padStart(2, '0');
			const seconds = String(date.getSeconds()).padStart(2, '0');
			return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
		}
	}
}
</script>

<style scoped>
.el-card {
	margin-top: 20px;
}

.el-table {
	margin-top: 15px;
}

.el-pagination {
	margin-top: 20px;
}
</style>
